import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { supabase } from '../supabase/client';

export default function PayRedirect() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!code) {
      setError('无效的链接');
      setLoading(false);
      return;
    }
    redirectToPay();
  }, [code]);

  const redirectToPay = async () => {
    try {
      const { data: shortLink, error: dbError } = await supabase
        .from('pay_short_urls')
        .select('pay_url, expires_at')
        .eq('short_code', code)
        .maybeSingle();

      if (dbError || !shortLink) {
        setError('链接不存在或已过期');
        setLoading(false);
        return;
      }

      if (shortLink.expires_at && new Date() > new Date(shortLink.expires_at)) {
        setError('链接已过期');
        setLoading(false);
        return;
      }

      window.location.href = shortLink.pay_url;
    } catch (err) {
      setError('跳转失败，请重试');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-10 h-10 text-blue-500 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">正在跳转支付宝...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <p className="text-gray-800 font-medium mb-2">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            返回首页
          </button>
        </div>
      </div>
    );
  }

  return null;
}
